module.exports = __webpack_public_path__ + "img/house_pv_off.6dda64e4.png";